import { Modal } from 'react-bootstrap';
import { useIntl } from 'react-intl';

import { InviteType } from 'constants/enums';
import Onboard from 'pages/Dashboard/Onboard/Onboard';

interface IAddDeviceProps {
  patient: IPatient | null | undefined;
  onClose: () => void;
  onRefetch: (status: boolean) => void;
}

const AddDevice = ({ patient, onClose, onRefetch }: IAddDeviceProps) => {
  const intl = useIntl();
  return (
    <Modal show onHide={onClose} size="xl" backdrop="static">
      <Modal.Header className="align-items-center" closeButton>
        <Modal.Title>{intl.formatMessage({ id: 'addDeviceKey' })}</Modal.Title>
      </Modal.Header>
      <Modal.Body className="pt-0" data-test="add-device-modal-body">
        <div className="position-relative">
          {patient && (
            <Onboard
              inviteType={InviteType.ORDER_PATIENT_DEVICE}
              patient={patient}
              fallback={(status: boolean) => {
                onRefetch(status);
                onClose();
              }}
            />
          )}
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default AddDevice;
